const indexItems = [
  { label: '娱乐圈', icon: 'ri-movie-line', desc: '明星八卦·合约内幕', count: '2,340篇' },
  { label: '商业圈', icon: 'ri-building-line', desc: '企业内幕·资本博弈', count: '1,890篇' },
  { label: '网红圈', icon: 'ri-live-line', desc: '主播争议·平台风波', count: '1,650篇' },
  { label: '科技界', icon: 'ri-cpu-line', desc: '数据泄露·技术黑幕', count: '1,420篇' },
  { label: '综艺界', icon: 'ri-tv-line', desc: '节目黑幕·幕后故事', count: '1,180篇' },
  { label: '体育界', icon: 'ri-football-line', desc: '赛事内幕·转会暗箱', count: '980篇' },
  { label: '政商圈', icon: 'ri-government-line', desc: '权力博弈·利益输送', count: '860篇' },
  { label: '海外站', icon: 'ri-global-line', desc: '国际爆料·跨境追踪', count: '740篇' },
  { label: '金融界', icon: 'ri-money-dollar-circle-line', desc: '金融暗箱·洗钱追踪', count: '620篇' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            主题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            按分类浏览所有专题合集，快速找到你感兴趣的内容领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group flex items-center gap-4 px-5 py-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300/40 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 text-xl shrink-0">
                <i className={item.icon} />
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 shrink-0">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}